import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Popover, message } from "antd";
import { find } from 'lodash';

import * as constants from '../../constants';
import InformationCarrierForm from './InformationCarrierForm';

import core from '../../../core';
import uistate from '../../../uistate';
import common from '../../../../common';

const { GenericTable } = core;


class InformationCarriersGrid extends Component {

    state = {
        addFormVisible: false,
        editFormVisible: false,
        currentEditEntity: {},
    };

    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'InformationCarriersGrid', key);
    }

    //#region Grid button handlers

    onAddClicked = (e) => {
        this.setState({
            currentEditEntity: { idProcessingActivity: this.props.idProcessingActivity, idInformationCarrier: -1 },
            addFormVisible: true,
        });
    }
    onDeleteClicked = (idx) => {
        this.props.arrayHelper.remove(idx);
    }
    onEditClicked = (id) => {
        const editentity = find(this.props.items, { 'idx': id });
        this.setState({
            currentEditEntity: editentity,
            editFormVisible: true,
        });
    }

    //#endregion    

    //#region Form handlers

    handleCancelForm = (e) => {
        this.setState({
            addFormVisible: false,
            editFormVisible: false,
            currentEditEntity: {},
        });
    }
    handleEntityAdd = (values) => {
        this.props.arrayHelper.push(values);
        this.setState({
            addFormVisible: false,
            currentEditEntity: {},
        });
    }

    handleEntityEdit = (values) => {
        this.props.arrayHelper.replace(values.idx, values);
        this.setState({
            editFormVisible: false,
            currentEditEntity: {},
        });
    }


    //#endregion

    render() {
        const readOnly = this.props.readOnly ? this.props.readOnly : false;
        const columns = [{
            title: this.label('InformationCarrier'),
            dataIndex: 'name',
            key: 'name',
            sorter: (a, b) => ('' + a.name).localeCompare(b.name),
        }, {
            title: this.label('RetentionPeriod'),
            dataIndex: 'retentionPeriod',
            key: 'retentionPeriod',
            sorter: (a, b) => ('' + a.retentionPeriod).localeCompare(b.retentionPeriod),
        }];

        return (
            <div className='ic'>
                <GenericTable aligntop multiline columns={columns} data={this.props.items} keyfield='idx' itemName={this.label('InformationCarrierItem')} pagesize={5}
                    onAdd={this.onAddClicked}
                    readOnly={readOnly}
                    onDelete={this.onDeleteClicked}
                    onEdit={this.onEditClicked}
                    onDoubleClick={this.onEditClicked} />

                <Modal title={this.label("AddModalTitleForm")} width='80%' destroyOnHidden={true} maskClosable={false}
                    open={this.state.addFormVisible}
                    footer={null}
                    onCancel={this.handleCancelForm}
                >
                    <InformationCarrierForm labels={this.props.labels} datacontext={this.state.currentEditEntity} onCancel={this.handleCancelForm} onSave={this.handleEntityAdd} />
                </Modal>

                <Modal title={this.label("EditModalTitleForm")} width='80%' destroyOnHidden={true} maskClosable={false}
                    open={this.state.editFormVisible}
                    footer={null}
                    onCancel={this.handleCancelForm}
                >
                    <InformationCarrierForm labels={this.props.labels} datacontext={this.state.currentEditEntity} onCancel={this.handleCancelForm} onSave={this.handleEntityEdit} />
                </Modal>

            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        labels: uistate.selectors.uiLabels(state),
    };
}

export default connect(mapStateToProps,
    {

    })
    (InformationCarriersGrid);  